import React from 'react';
import { resolveVideoPlayUrl } from '../../utils/lessonHelpers';

interface GoogleDriveVideoPlayerProps {
  url: string;
}

const GoogleDriveVideoPlayer: React.FC<GoogleDriveVideoPlayerProps> = ({ url }) => (
  <iframe
    src={resolveVideoPlayUrl(url)}
    className="w-full h-full absolute inset-0 border-0"
    allow="autoplay; encrypted-media; fullscreen"
    allowFullScreen
    title="Google Drive Video"
  />
);

export default GoogleDriveVideoPlayer;
